require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/modules/es7.symbol.observable.js
// module id = 498
// module chunks = 69